import { render, staticRenderFns } from "./LanguageConfiguration.vue?vue&type=template&id=2ae95d8e"
import script from "./LanguageConfiguration.vue?vue&type=script&lang=js"
export * from "./LanguageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./LanguageConfiguration.vue?vue&type=style&index=0&id=2ae95d8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports